<template>
  <div class="bill">
    <van-nav-bar
      title="奖励明细"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="list">
      <div v-for="item in list" :key=item class="item">
        <div v-if="item.data_type == 1" class="total">
          <div>{{item.title}}</div>
          <div>+{{item.money}}元</div>
        </div>
        <div v-else class="detail">
          <div>
            <p>{{item.title}}</p>
            <p>{{item.time}}</p>
          </div>
          <div>
            +{{item.money}}元
          </div>
        </div>
      </div>
    </div>
    
    <loading :isLoad="isLoad"></loading>
  </div>
</template>

<script>

import Vue from 'vue';
import { NavBar } from 'vant';
import Loading from '@/components/Loading'
Vue.use(NavBar)

export default {
  components: {
    Loading
  },
  created() {
    this.userid = this.getCookie('userid')
    this.activityId = this.$route.query.activity_id
    if (this.$route.query.debug == 1) {
      this.userid = this.$route.query.userid
    }

    this.getList()
  },
  data() {
    return {
      userid: '',
      activityId: '',
      list: []
    }
  },
  methods: {
    getCookie: function (name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return ""
    },
    getList: function() {
      const params = {
        activity_id: this.activityId,
        userid: this.userid
      }
      this.isLoad = true
      this.$http.get('/api/treasure/bill', {params: params}).then((res) => {
        this.isLoad = false
        this.list = res.data
      })
    },
    onClickLeft: function () {
      this.$router.push({path: '/activity/buyu', query: {userid: this.userid, activity_id: this.activityId}})
    }
  }
}
</script>

<style lang="less" scoped>
.bill {
  display: block;
  width: 100%;
  max-width: 3.75rem;
  min-height: calc(100vh - 0.26rem);
  overflow: hidden;

  .list {
    display: block;
    width: 100%;
    overflow: hidden;

    .item {
      display: block;
      width: 100%;
      overflow: hidden;

      .total, .detail {
        display: block;
        width: calc(100% - .32rem);
        padding: 0 .16rem;        
      }
      .total {
        height: .36rem;
        line-height: .36rem;
        background: #F7F8FA;
        overflow: hidden;

        div:first-child {
          float: left;
          font-size: 14px;
          color: #999999;
        }
        div:last-child {
          float: right;
          font-size: 14px;
          color: #FF7F4B;
        }
      }
      .detail {
        display: flex;
        height: .75rem;
        background: #FFFFFF;
        align-items: center;
        border-bottom: .01rem solid #F7F8FA;
        overflow: hidden;
        
        div:first-child {
          display: flex;
          height: .46rem;
          margin-left: 0;
          overflow: hidden;
          flex-direction: column;
          justify-content: space-around;

          p:first-child {
            font-size: 14px;
            color: #333333;
          }
          p:last-child {
            font-size: 12px;
            color: #999999;
          }
        }
        div:last-child {
          display: block;
          height: .46rem;
          font-size: 16px;
          color: #333333;
          margin-left: auto;
          margin-right: 0;
          overflow: hidden;
        }
      }
      .detail::before {
        content: ' ';
        width: .3rem;
        height: .3rem;
        background: url('~@/assets/images/activity_buyu/money.png') no-repeat;
        background-size: .3rem;
        margin-right: .16rem;
        overflow: hidden;
      }
      .detail:last-child {
        border: 0;
      }
    }
  }
  /deep/ .van-nav-bar{
    margin-top: .26rem;
  }
  /deep/.van-icon {
    color: #666666;
  }
  /deep/.van-nav-bar__title {
    font-size: 18px;
    color: #333333;
  } 
}
</style>